<mat-dialog-content>
    <div class="container w-full">
        <h3 class="font-bold flex flex-start mb-4">Expense Per Diem Breakout</h3>
        <div class="w-full h-full mt-2">
            <p-table stripedRows #dataTable
                [columns]="cols"
                [value]="items"
                dataKey="Contractlistid"
                editMode="row"
                [scrollable]="true"
                scrollHeight="flex"
                sortField="Contractdesc"
                [sortOrder]="1"
            >
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="4" style="text-align: center">
                            <div class="tabulator-placeholder">
                                <span> No Data Available </span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td style="text-align: center">
                            <div>
                                Loading...<i class="fa fa-spinner fa-spin"></i>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="header" let-item let-columns>
                    <tr>
                        <th *ngFor="let col of columns" class="title-case">
                            {{ GetHeaderName(col) }}
                        </th>
                    </tr>
                </ng-template>
                <ng-template
                    pTemplate="body"
                    let-item
                    let-columns="columns"
                    let-edit="editing"
                    let-ri="rowIndex"
                >
                    <tr>
                        <td *ngFor="let col of columns">
                            <ng-template #checkbox> </ng-template>
                            <ng-template #other>
                                {{ item[col.field] }}
                            </ng-template>
                            <div *ngIf="col.field === 'inuse'">
                                <p-checkbox
                                    [(ngModel)]="item[col.field]"
                                    [binary]="true"
                                ></p-checkbox>
                            </div>
                            <div *ngIf="col.field !== 'inuse'">
                                <span *ngIf="col.field.includes('date')">
                                    {{ item[col.field] | date: 'MM/dd/yyyy' }}
                                </span>
                                <span *ngIf="!col.field.includes('date')">
                                    {{ item[col.field] }}
                                </span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="w-full flex items-center justify-end gap-2" style="margin-top: -8rem;">
            <button
                type="button"
                pButton
                label="Save"
                aria-label="Save"
                (click)="this.onSave(dataTable.value)"
                class="p-button-success"
            ></button>
            <button
                type="button"
                pButton
                label="Cancel"
                aria-label="Cancel"
                icon="pi pi-times"
                class="p-button-danger"
                (click)="this.onCancel()"
            ></button>
        </div>
    </div>
</mat-dialog-content>
